import { render, staticRenderFns } from "./UrgentQuery.vue?vue&type=template&id=68e72377&scoped=true&"
import script from "./UrgentQuery.vue?vue&type=script&lang=js&"
export * from "./UrgentQuery.vue?vue&type=script&lang=js&"
import style0 from "./UrgentQuery.vue?vue&type=style&index=0&id=68e72377&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e72377",
  null
  
)

export default component.exports